export default __webpack_public_path__ + "static/media/st-text.ccc19510.svg";